const messages = {
  /*  form error messgaes for bride  */
  BRIDE_FIRST_NAME_ERROR: "Bride's Name can not be empty",
  BRIDE_FATHER_NAME_ERROR: "Bride's Father's Name can not be empty",
  BRIDE_MOTHER_NAME_ERROR: "Bride's Mother's Name can not be empty",

  /*eror messages for for groom*/

  GROOM_FIRST_NAME_ERROR: "Groom's Name can not be empty",
  GROOM_FATHER_NAME_ERROR: "Groom's Father's Name can not be empty",
  GROOM_MOTHER_NAME_ERROR: "Groom's Mother's Name can not be empty",

  PROGRAMME_NAME_ERROR: "Programme Name can not be empty",
  PROGRAMME_DATE_ERROR: "Programme Date can not be empty",
  PROGRAMME_TIME_ERROR: "Programme Time can not be empty",
  PROGRAMME_VENUE_ERROR: "Programme Venue can not be empty",

  MAIN_DATE_ERROR: "Main Date can not be empty",
  MAIN_VENUE_ERROR: "Main Venue can not be empty",

  FULLNAME_ERROR: "Name can not be empty",
  MESSAGE_ERROR: "Message can not be empty"
};

export default messages;
